import { render, staticRenderFns } from "./LocationVariationList.vue?vue&type=template&id=2def3662"
import script from "./LocationVariationList.vue?vue&type=script&lang=js"
export * from "./LocationVariationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports